function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { H2 } from '@finect/tabular-core/Headings';
import { withTheme } from 'styled-components';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { Flex } from '@finect/tabular-core/Flex';
import { getClassesWithCommercializations, getFundsSheetPath, getProductTypeByAPISubtype } from '@finect/front-resources/Products';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Modal } from '../../Modal';
import { Table } from '../../Table';
import { PercentLabel, AssetsLabel } from '../../Products/Labels';
import { FundClassMinInvestment } from '../../Products/ProductsTable/ProductRow/FundMinInvestment';
import { ProductDistributors } from '../../Products/ProductsTable/ProductRow/ProductDistributors';
import { InnerSpacing, TableScrollable, CleanClassTag, ISINLabel } from './partials';
export var ClassesModal = function ClassesModal(_ref) {
  var fund = _ref.fund,
    show = _ref.show,
    onClose = _ref.onClose,
    theme = _ref.theme;
  var productType = getProductTypeByAPISubtype(fund.subtype);
  var columns = ['Clases disponibles', 'ISIN', 'Dónde lo puedes comprar', 'Útimo valor liquidativo', 'Rentabilidad 3 años', 'Inversión mínima', 'Coste de Gestión', ''];
  var classes = !['plan'].includes(productType) ? getClassesWithCommercializations(fund) : [];
  var rows = classes.sort(function (a, b) {
    return a.annualizedPerformance.value > b.annualizedPerformance.value ? -1 : 1;
  }).map(function (fundClass, index) {
    var productClass = _objectSpread(_objectSpread({}, fund), fundClass);
    var productPath = getFundsSheetPath(theme, productType, productClass);
    var isActiveFundClass = fundClass.id === fund.class.id;
    var cleanClassesCommercializations = fundClass.commercializations.filter(function (_ref2) {
      var security = _ref2.security;
      return security.clean && security.id === fundClass.id;
    });
    return [React.createElement("span", {
      key: index
    }, React.createElement("div", null, React.createElement(AppLink, {
      href: productPath,
      title: "Ver clase ".concat(fundClass.name, " (").concat(fundClass.isin, ")")
    }, fundClass.name)), cleanClassesCommercializations.length ? React.createElement(CleanClassTag, null, "Clase limpia") : ''), React.createElement("span", {
      key: index
    }, React.createElement(ISINLabel, {
      isActive: isActiveFundClass
    }, fundClass.isin)), React.createElement(Flex, {
      key: index
    }, React.createElement(ProductDistributors, {
      entity: fundClass
    })), React.createElement(AssetsLabel, {
      key: index,
      value: fundClass.lastQuote.price,
      currency: fundClass.currency.code
    }), React.createElement(PercentLabel, {
      key: index,
      bold: true,
      withSparkline: true,
      decimals: 2,
      value: fundClass.annualizedPerformance ? fundClass.annualizedPerformance.value : null
    }), React.createElement(FundClassMinInvestment, {
      key: index,
      fundClass: fundClass
    }), React.createElement(PercentLabel, {
      key: index,
      decimals: 3,
      value: fundClass.fees.mgr ? fundClass.fees.mgr.value : null
    })];
  });
  return React.createElement(Modal, {
    withDOM: true,
    onClose: onClose,
    show: show,
    fullScreen: true
  }, React.createElement(InnerSpacing, null, React.createElement(H2, null, fund.name), React.createElement(TableScrollable, null, React.createElement(Table, {
    textAlign: "center",
    small: true,
    columns: columns,
    rows: rows,
    firstColumnFixed: true,
    firstColumnAsTh: true
  }), React.createElement(ParagraphSmall, {
    light: true
  }, "*Rentabilidad anualizada"))));
};
export default withTheme(ClassesModal);